import { handleActions } from "redux-actions";

import {
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_MODULE_VIEW,
  SET_LOADING,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  IN_STORE_DATA_SUCCESS,
  CROSS_CLUB_RANKING_DATA_SUCCESS,
  UPDATE_CUSTOM_RANGE,
  UPDATE_FILTER,
  UPDATE_DATES,
  RESET_SELECTED_FILTERS
} from "./memberVisitsSaga";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

export const initialState = {
  currentUser: {},
  isLoading: false,
  moduleView: [
    { id: "inStoreVsCrossClub", name: "In Store vs Cross Club" },
    { id: "crossClubRanking", name: "Cross Club Ranking" }
  ],
  rangeOptions: [],
  filters: {
    period_days: [],
    membership_types: []
  },
  selectedFilters: {
    moduleView: { id: "inStoreVsCrossClub", name: "In Store vs Cross Club" },
    period_days: { id: 90, name: "90 days" },
    membership_types: [],
    rangeOption: {},
    requestDates: {},
    date: null
  },
  tableInfo: {},
  scorecards: null,
  initialRequest: false,
  filtersDirty: false
};

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        date: action.payload.calendarEndDate
      }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: {
        ...action.payload
      },
      selectedFilters: {
        ...state.selectedFilters,
        ...(action.payload.membership_types && {
          membership_types: action.payload.membership_types
        })
      }
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    [RESET_SELECTED_FILTERS]: (state) => ({
      ...state,
      selectedFilters: {
        ...initialState.selectedFilters,
        moduleView: state.selectedFilters.moduleView
      }
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedFilters: {
        ...state.selectedFilters,
        rangeOption: getSelectedRangeOption(action),
        date: state.currentUser.calendarEndDate,
        requestDates: action.payload
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        rangeOption: action.payload,
        requestDates: getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        )
      },
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        rangeOption: getSelectedRangeOptionWithCustom(action),
        requestDates: action.payload || state.selectedFilters.requestDates
      },
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      filtersDirty: true
    }),
    [CROSS_CLUB_RANKING_DATA_SUCCESS]: (state, action) => ({
      ...state,
      tableInfo: { ...action.payload.table_data },
      scorecards: action.payload.score_cards
    }),
    [IN_STORE_DATA_SUCCESS]: (state, { payload: { data_points, pie_charts } }) => ({
      ...state,
      dataPoints: data_points,
      pieCharts: pie_charts
    }),
    [SET_MODULE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        moduleView: action.payload
      }
    })
  },
  initialState
);
